/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { vec3 } from "../../util/geom";
const annotationChunkDataSize = vec3.fromValues(128, 128, 128);
export var VolumeChunkEncoding;
(function (VolumeChunkEncoding) {
    VolumeChunkEncoding[VolumeChunkEncoding["JPEG"] = 0] = "JPEG";
    VolumeChunkEncoding[VolumeChunkEncoding["RAW"] = 1] = "RAW";
    VolumeChunkEncoding[VolumeChunkEncoding["COMPRESSED_SEGMENTATION"] = 2] = "COMPRESSED_SEGMENTATION";
    VolumeChunkEncoding[VolumeChunkEncoding["COMPRESSED_SEGMENTATIONARRAY"] = 3] = "COMPRESSED_SEGMENTATIONARRAY";
})(VolumeChunkEncoding || (VolumeChunkEncoding = {}));
export class DVIDSourceParameters {}
export class VolumeChunkSourceParameters extends DVIDSourceParameters {}
VolumeChunkSourceParameters.RPC_ID = 'dvid/VolumeChunkSource';
export class SkeletonSourceParameters extends DVIDSourceParameters {}
SkeletonSourceParameters.RPC_ID = 'dvid/SkeletonSource';
export class MeshSourceParameters extends DVIDSourceParameters {}
MeshSourceParameters.RPC_ID = 'dvid/MeshSource';
export class AnnotationSourceParametersBase extends DVIDSourceParameters {
    constructor() {
        super(...arguments);
        this.chunkDataSize = annotationChunkDataSize;
    }
}
export class AnnotationSourceParameters extends AnnotationSourceParametersBase {}
AnnotationSourceParameters.RPC_ID = 'dvid/AnnotationSource';
export class AnnotationChunkSourceParameters extends AnnotationSourceParametersBase {}
AnnotationChunkSourceParameters.RPC_ID = 'dvid/AnnotationChunkSource';
//# sourceMappingURL=base.js.map